import { StaticImageData } from 'next/image'
import {
  logoLightTr,
  logoNightTr,
  logoLightMt,
  logoNightMt,
  logoLightHk,
  logoNightHk,
  logoLightUs,
  logoNightUs,
  logoLightBs,
  logoNightBs,
  logoLightSG,
  logoNightSG,
  LogoLightUK,
  LogoNightUK,
  LogoLightJP,
  LogoNightJP,
  LogoLightUAE,
  LogoNightUAE,
} from '../assets/images/siteConfig'

interface SupportData {
  name: string
  url: string
}
interface BusinessData {
  name: string
  url: string
}

interface DocsData {
  agreement: string
  privacy_policy: string
  licenses?: string
  about?: string
}

interface ILogoWithBase64 extends StaticImageData {
  base64?: string
}

/**
 *  站点配置信息
 *  id   对应key 为后台set的 sub_website_id(取值来源: 国家id)   *注意主站id=0
 *  key  站点标识 主站为index
 *  name 站点名称
 *  collectId 埋点id
 *  hiddenAppDownload 是否开放app下载 为true时隐藏app相关功能 如扫码登录
 *  hiddenThemeSwitch 隐藏皮肤切换
 *  hiddenNotification 隐藏站内信
 *  hiddenLangAndRate 隐藏语言/汇率切换
 *  hiddenReferral 禁用邀请返佣
 *  logo: [{lightUrl}, {darkUrl}]
 *  ws: []
 *  authorizedLogin: [三方登录支持渠道]  ['google', 'metamask', 'apple', 'gateio'] gateio代表授权登录
 *  chatroom: 是否支持聊天室
 *  bigData: 是否支持大数据
 *  totpName: 谷歌验证器显示名称
 *  anti: 登录钓鱼码
 */
export type configSiteContext = {
  id: number
  key: string
  name: string
  tradingViewExchange?: string
  collectId: number
  gtagId: string
  logo: ILogoWithBase64[]
  ws: string[]
  authorizedLogin: string[]
  chatroom: number
  bigData: number
  support: SupportData
  business: BusinessData
  totpName: string
  anti: string[]
  defaultCurrB?: string
  hiddenAppDownload?: number
  hiddenFooterSignup?: number
  hiddenReferral?: number
  hiddenThemeSwitch?: number
  hiddenNotification?: number
  hiddenLangAndRate?: number
  docs?: DocsData
  defaultLang?: string
}

interface Config {
  siteConfig: Record<string, configSiteContext>
}

const logoBase64 =
  'data:image/png;base64,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'

const fullHeightLogo =
  'data:image/png;base64,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'

export const webSiteConfig: Config = {
  siteConfig: {
    '0': {
      id: 0,
      key: 'index',
      name: 'Gate.io',
      collectId: 10000001,
      gtagId: 'GTM-5GK34VS',
      logo: [
        {
          src: `${process.env.NEXT_PUBLIC_PREFIX}/static/logo/open_sesame_light.png`,
          width: 360,
          height: 72,
        },
        {
          src: `${process.env.NEXT_PUBLIC_PREFIX}/static/logo/open_sesame_night.png`,
          base64: fullHeightLogo,
          width: 360,
          height: 72,
        },
      ],
      ws: ['webws.gateio.live', 'webws.gateio.live'],
      authorizedLogin: ['google', 'metamask', 'apple'],
      chatroom: 1,
      bigData: 1,
      support: {
        name: 'support@mail.gate.io',
        url: 'mailto:support@mail.gate.io',
      },
      business: {
        name: 'business@gate.io',
        url: 'mailto:business@gate.io',
      },
      totpName: 'gate.io',
      anti: ['https://www.gate.io', 'https://www.gate.ac', 'https://www.gate.info'],
      defaultLang: 'en',
      docs: {
        agreement: '/user-agreement',
        privacy_policy: '/privacy-policy',
      },
    },
    '177': {
      id: 177,
      key: 'turkey',
      name: 'Gate.TR',
      collectId: 10000004,
      gtagId: 'GTM-5GK34VS',
      logo: [logoLightTr, logoNightTr],
      ws: ['webws.gateio.live', 'webws.gateio.live'],
      authorizedLogin: ['gateio'],
      chatroom: 1,
      bigData: 1,
      defaultCurrB: 'try',
      support: {
        name: 'support@mail.gate.io',
        url: 'mailto:support@mail.gate.io',
      },
      business: {
        name: 'business@gate.io',
        url: 'mailto:business@gate.io',
      },
      totpName: 'gate.tr',
      anti: ['https://www.gate.com.tr'],
      defaultLang: 'tr',
      docs: {
        agreement: '/user-agreement',
        privacy_policy: '/privacy-policy',
      },
    },
    '106': {
      id: 106,
      key: 'malta',
      name: 'Gate.MT',
      collectId: 10000006,
      gtagId: 'GTM-5GK34VS',
      logo: [logoLightMt, logoNightMt],
      ws: ['ws.gatemt.com'],
      hiddenAppDownload: 1,
      hiddenNotification: 1,
      hiddenFooterSignup: 1,
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'support@gate.mt',
        url: 'mailto:support@gate.mt',
      },
      business: {
        name: 'info@gate.mt',
        url: 'mailto:info@gate.mt',
      },
      docs: {
        agreement: 'https://gimg.gateio.eu/doc/172968040274285784User_Agreement_18-10-2024.pdf',
        privacy_policy: '',
      },
      totpName: 'gate.mt',
      anti: ['https://www.gatemt.com'],
    },
    '71': {
      id: 71,
      key: 'hongkong',
      name: 'Gate.HK',
      collectId: 10000007,
      gtagId: 'G-YX54KN8Y1K',
      logo: [logoLightHk, logoNightHk],
      ws: ['ws.gate.hk'],
      hiddenAppDownload: 1,
      hiddenNotification: 1,
      hiddenReferral: 1,
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'account@gate.hk',
        url: 'mailto:account@gate.hk',
      },
      business: {
        name: 'account@gate.hk',
        url: 'mailto:account@gate.hk',
      },
      docs: {
        agreement: '/docs/hk_agreement.pdf?v=',
        privacy_policy: '/docs/hk_privacy_policy.pdf?v=',
      },
      hiddenFooterSignup: 1,
      totpName: 'gate.hk',
      anti: ['https://www.gate.hk'],
    },
    '232': {
      id: 232,
      key: 'america',
      name: 'Gate.US',
      tradingViewExchange: 'GATEUS',
      collectId: 10000005,
      gtagId: 'GTM-5GK34VS',
      hiddenAppDownload: 1,
      hiddenThemeSwitch: 1,
      hiddenNotification: 1,
      hiddenLangAndRate: 1,
      hiddenReferral: 1,
      logo: [logoLightUs, logoNightUs],
      ws: ['us-ws.9global.net'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'account@gate.us',
        url: 'mailto:account@gate.us',
      },
      business: {
        name: 'account@gate.us',
        url: 'mailto:account@gate.us',
      },
      docs: {
        agreement: '/docs/gate_us_UserAgreement.html?v=2',
        privacy_policy: '/docs/gate_us_PrivacyPolicy.html?v=2',
        licenses: '/docs/gate_us_Licenses.html?v=2',
        about: '',
      },
      hiddenFooterSignup: 1,
      totpName: 'gate.us',
      anti: ['https://www.gate.us'],
    },
    '14': {
      id: 14,
      key: 'bahamas',
      name: 'Gate BS',
      collectId: 10000008,
      gtagId: 'GTM-5GK34VS',
      hiddenAppDownload: 1,
      hiddenReferral: 1,
      logo: [logoLightBs, logoNightBs],
      ws: ['webws.gateio.live', 'webws.gateio.live'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'account@gate.bs',
        url: 'mailto:account@gate.bs',
      },
      business: {
        name: 'account@gate.bs',
        url: 'mailto:account@gate.bs',
      },
      docs: {
        agreement: '/docs/bs_agreement.pdf?v=',
        privacy_policy: '/docs/bs_privacy_policy.pdf?v=',
      },
      hiddenFooterSignup: 0,
      totpName: 'gate.bs',
      anti: [''],
    },
    '153': {
      id: 153,
      key: 'singapore',
      name: 'Gate SG',
      collectId: 10000001,
      gtagId: 'GTM-5GK34VS',
      hiddenAppDownload: 1,
      hiddenReferral: 1,
      // 需要修改成新的logo
      logo: [logoLightSG, logoNightSG],
      ws: ['webws.gateio.live', 'webws.gateio.live'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'support@mail.gate.io',
        url: 'mailto:support@mail.gate.io',
      },
      business: {
        name: 'business@gate.io',
        url: 'mailto:business@gate.io',
      },
      docs: {
        agreement: '/docs/hk_agreement.pdf?v=',
        privacy_policy: '/docs/hk_privacy_policy.pdf?v=',
      },
      hiddenFooterSignup: 0,
      totpName: 'gate.uk',
      anti: ['https://www.gate.uk'],
    },
    '182': {
      id: 182,
      key: 'united_kingdom',
      name: 'Gate.UK',
      tradingViewExchange: 'GATEUK',
      collectId: 10000001,
      gtagId: 'GTM-5GK34VS',
      hiddenAppDownload: 1,
      hiddenReferral: 1,
      logo: [LogoLightUK, LogoNightUK],
      ws: ['webws.gateio.live'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'support@mail.gate.io',
        url: 'mailto:support@mail.gate.io',
      },
      business: {
        name: 'business@gate.io',
        url: 'mailto:business@gate.io',
      },
      totpName: 'gate.uk',
      anti: ['https://www.gate.uk'],
    },
    '83': {
      id: 83,
      key: 'japan',
      name: 'Gate.JP',
      tradingViewExchange: 'GATEJP',
      collectId: 10000014,
      gtagId: 'GTM-5GK34VS',
      hiddenAppDownload: 1,
      hiddenReferral: 1,
      logo: [LogoLightJP, LogoNightJP],
      ws: ['webws.gateio.live'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'support@gate.jp',
        url: 'mailto:support@gate.jp',
      },
      business: {
        name: 'business@gate.jp',
        url: 'mailto:business@gate.jp',
      },
      docs: {
        agreement: '',
        privacy_policy: '',
      },
      hiddenFooterSignup: 0,
      totpName: 'gate.jp',
      anti: ['https://www.gate.jp'],
    },
    '181': {
      id: 181,
      key: 'united_arab_emirates',
      name: 'Gate.UAE',
      tradingViewExchange: 'GATEUAE',
      collectId: 10000012,
      gtagId: 'GTM-5GK34VS',
      hiddenAppDownload: 1,
      hiddenReferral: 1,
      logo: [LogoLightUAE, LogoNightUAE],
      ws: ['ws.gate.ae'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'support@mail.gate.io',
        url: 'mailto:support@mail.gate.io',
      },
      business: {
        name: 'business@gate.io',
        url: 'mailto:business@gate.io',
      },
      docs: {
        agreement: '',
        privacy_policy: '',
      },
      hiddenFooterSignup: 0,
      totpName: 'gate.ae',
      anti: ['https://www.gate.ae'],
    },
    '666': {
      id: 666,
      key: 'index',
      name: 'Gate.io',
      collectId: 10000001,
      gtagId: 'GTM-5GK34VS',
      logo: [
        {
          src: `${process.env.NEXT_PUBLIC_PREFIX}/static/logo/open_sesame_light.png`,
          width: 360,
          height: 72,
        },
        {
          src: `${process.env.NEXT_PUBLIC_PREFIX}/static/logo/open_sesame_night.png`,
          base64: fullHeightLogo,
          width: 360,
          height: 72,
        },
      ],
      ws: ['webws.gateio.live', 'webws.gateio.live'],
      authorizedLogin: ['google', 'metamask', 'apple'],
      chatroom: 1,
      bigData: 1,
      support: {
        name: 'support@mail.gate.io',
        url: 'mailto:support@mail.gate.io',
      },
      business: {
        name: 'business@gate.io',
        url: 'mailto:business@gate.io',
      },
      totpName: 'gate.io',
      anti: ['https://www.gate.io', 'https://www.gate.ac', 'https://www.gate.info'],
      defaultLang: 'en',
    },
    '777': {
      id: 777,
      key: 'index',
      name: 'Gate.io',
      collectId: 10000015,
      gtagId: 'GTM-5GK34VS',
      logo: [
        {
          src: `${process.env.NEXT_PUBLIC_PREFIX}/static/logo/open_sesame_light.png`,
          width: 360,
          height: 72,
        },
        {
          src: `${process.env.NEXT_PUBLIC_PREFIX}/static/logo/open_sesame_night.png`,
          base64: fullHeightLogo,
          width: 360,
          height: 72,
        },
      ],
      ws: ['webws.gateio.live'],
      authorizedLogin: [],
      chatroom: 0,
      bigData: 0,
      support: {
        name: 'support_eu@mail.gate.io',
        url: 'mailto:support_eu@mail.gate.io',
      },
      business: {
        name: 'institutional_eu@gate.io',
        url: 'mailto:institutional_eu@gate.io',
      },
      totpName: 'Gate.io EU',
      anti: ['https://www.gate.io/en-eu'],
      defaultLang: 'en',
    },
  },
}
